/**
 * search-suggest.js — dropdown gợi ý dưới ô tìm kiếm header (mục 21).
 *
 * Chưa gõ: "Tìm kiếm gần đây" (localStorage, tối đa 5) + "Phổ biến".
 * Đang gõ: từ khoá gợi ý (phần trùng in đậm) → sản phẩm khớp → "Xem tất cả kết quả".
 * So khớp bỏ dấu tiếng Việt ("y" khớp "Ý", "cab" khớp "Cabernet") vì khách gõ không
 * dấu trên điện thoại rất thường.
 *
 * Bàn phím: ↑/↓ chọn dòng, Enter mở dòng đang chọn (không chọn thì gửi form), Esc đóng.
 * Dữ liệu lấy từ WBCatalog (catalog.js — dữ liệu mẫu).
 * WP: thay hàm matches() bằng fetch tới endpoint AJAX (WP_Query 's' + post_type product).
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var KEY_RECENT = 'wb_recent_search';
    var form = document.querySelector('[data-search]');
    if (!form) return;

    var input = form.querySelector('[data-search-input]');
    var panel = form.querySelector('[data-search-suggest]');
    if (!input || !panel) return;

    var activeIndex = -1;

    function esc(value) {
        return String(value).replace(/[&<>"']/g, function (ch) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
        });
    }

    // Bỏ dấu để so khớp. Với chuỗi NFC (mỗi chữ có dấu là MỘT ký tự), bỏ dấu xong vẫn
    // đúng số ký tự như trước, nên vị trí tìm được trên bản bỏ dấu cắt thẳng trên bản gốc.
    function fold(value) {
        return String(value)
            .normalize('NFD')
            .replace(/[̀-ͯ]/g, '')
            .replace(/đ/g, 'd')
            .replace(/Đ/g, 'D')
            .toLowerCase();
    }

    function highlight(text, query) {
        text = text.normalize('NFC');
        query = query.normalize('NFC');
        var at = fold(text).indexOf(fold(query));
        if (at < 0) return esc(text);
        return esc(text.slice(0, at)) + '<strong>' + esc(text.slice(at, at + query.length)) + '</strong>' + esc(text.slice(at + query.length));
    }

    function recent() {
        try {
            return JSON.parse(window.localStorage.getItem(KEY_RECENT)) || [];
        } catch (e) {
            return [];
        }
    }

    function remember(term) {
        term = term.trim();
        if (!term) return;
        var list = recent().filter(function (t) {
            return fold(t) !== fold(term);
        });
        list.unshift(term);
        try {
            window.localStorage.setItem(KEY_RECENT, JSON.stringify(list.slice(0, 5)));
        } catch (e) {
            /* bỏ qua */
        }
    }

    function searchUrl(term) {
        return form.getAttribute('action') + '?s=' + encodeURIComponent(term);
    }

    function catalog() {
        return window.WBCatalog;
    }

    function renderEmpty() {
        var cat = catalog();
        var items = recent();
        var html = '';

        if (items.length) {
            html += '<div class="search-suggest__group"><p class="search-suggest__label"><span>Tìm kiếm gần đây</span>' +
                '<button type="button" data-search-clear>Xoá</button></p><div class="chip-list">';
            items.forEach(function (term) {
                html += '<a class="chip chip--outline-sm" href="' + esc(searchUrl(term)) + '" data-suggest-item>' +
                    '<i class="ph-bold ph-clock" aria-hidden="true"></i>' + esc(term) + '</a>';
            });
            html += '</div></div>';
        }

        if (cat) {
            html += '<div class="search-suggest__group"><p class="search-suggest__label"><span>Phổ biến</span></p><div class="chip-list">';
            cat.popular.forEach(function (term) {
                html += '<a class="chip chip--soft" href="' + esc(searchUrl(term)) + '" data-suggest-item>' +
                    '<i class="ph-fill ph-lightning" aria-hidden="true"></i>' + esc(term) + '</a>';
            });
            html += '</div></div>';
        }
        return html;
    }

    function renderQuery(query) {
        var cat = catalog();
        if (!cat) return '';
        var q = fold(query);
        var html = '';

        var terms = cat.keywords
            .filter(function (k) {
                return fold(k).indexOf(q) !== -1;
            })
            .slice(0, 4);

        if (terms.length) {
            html += '<div class="search-suggest__terms">';
            terms.forEach(function (term) {
                html += '<a href="' + esc(searchUrl(term)) + '" data-suggest-item>' +
                    '<i class="ph-bold ph-magnifying-glass" aria-hidden="true"></i><span>' + highlight(term, query) + '</span></a>';
            });
            html += '</div>';
        }

        var products = cat.all().filter(function (p) {
            return fold([p.name, p.country, p.region, p.grape, p.type].join(' ')).indexOf(q) !== -1;
        });

        html += '<p class="search-suggest__heading">Sản phẩm · ' + products.length + '</p>';

        if (!products.length) {
            html += '<p class="search-suggest__empty">Không có sản phẩm khớp. Thử từ khoá khác hoặc hỏi sommelier.</p>';
        }

        products.slice(0, 4).forEach(function (p) {
            html += '<a class="search-suggest__product" href="' + esc(p.url) + '" data-suggest-item>' +
                '<span class="thumb"><img src="' + esc(p.image) + '" alt="" width="600" height="800" /></span>' +
                '<span class="search-suggest__name"><strong>' + esc(p.name) + '</strong>' +
                '<span><img class="flag flag--sm" src="images/flags/' + esc(p.flag) + '.png" alt="" width="40" height="27" />' +
                esc(p.country) + ' · ' + esc(p.year) + '</span></span>' +
                '<span class="search-suggest__price">' + window.WBStore.money(p.price) + '</span></a>';
        });

        html += '<a class="search-suggest__all" href="' + esc(searchUrl(query)) + '" data-suggest-item>' +
            '<span>Xem tất cả kết quả cho “' + esc(query) + '”</span><i class="ph-bold ph-arrow-right" aria-hidden="true"></i></a>';
        return html;
    }

    function items() {
        return [].slice.call(panel.querySelectorAll('[data-suggest-item]'));
    }

    function setActive(index) {
        var list = items();
        activeIndex = index;
        list.forEach(function (el, i) {
            el.classList.toggle('is-active', i === index);
        });
        if (list[index]) list[index].scrollIntoView({ block: 'nearest' });
    }

    function open() {
        var query = input.value.trim();
        var html = query ? renderQuery(query) : renderEmpty();
        panel.innerHTML = html;
        var show = !!html;
        panel.hidden = !show;
        form.classList.toggle('is-suggesting', show);
        input.setAttribute('aria-expanded', show ? 'true' : 'false');
        activeIndex = -1;
    }

    function close() {
        panel.hidden = true;
        form.classList.remove('is-suggesting');
        input.setAttribute('aria-expanded', 'false');
        activeIndex = -1;
    }

    var timer;
    input.addEventListener('focus', open);
    input.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(open, 120);
    });

    input.addEventListener('keydown', function (event) {
        var list = items();
        if (event.key === 'ArrowDown') {
            event.preventDefault();
            if (panel.hidden) open();
            setActive(Math.min(activeIndex + 1, list.length - 1));
        } else if (event.key === 'ArrowUp') {
            event.preventDefault();
            setActive(Math.max(activeIndex - 1, -1));
        } else if (event.key === 'Enter' && activeIndex > -1 && list[activeIndex]) {
            event.preventDefault();
            window.location.href = list[activeIndex].getAttribute('href');
        } else if (event.key === 'Escape' || event.key === 'Esc') {
            close();
        }
    });

    panel.addEventListener('mousedown', function (event) {
        // Giữ focus ở ô nhập khi bấm vào dropdown, nếu không blur sẽ đóng dropdown trước khi click kịp chạy
        if (event.target.closest('[data-search-clear]')) event.preventDefault();
    });

    panel.addEventListener('click', function (event) {
        if (event.target.closest('[data-search-clear]')) {
            try {
                window.localStorage.removeItem(KEY_RECENT);
            } catch (e) {
                /* bỏ qua */
            }
            open();
            input.focus();
        }
    });

    form.addEventListener('submit', function () {
        remember(input.value);
    });

    document.addEventListener('click', function (event) {
        if (!form.contains(event.target)) close();
    });

    form.addEventListener('focusout', function (event) {
        if (event.relatedTarget && form.contains(event.relatedTarget)) return;
        window.setTimeout(function () {
            if (!form.contains(document.activeElement)) close();
        }, 0);
    });
})();
